export default __webpack_public_path__ + "static/media/Program.b6be427f.svg";